module.exports = __webpack_public_path__ + "img/edge_divers_camping_car.02a6dd09.svg";